import { Alert, Button, Stack, Typography } from '@mui/material'
import { queryClient } from 'queries/queryClient'
import { useMemo } from 'react'
import { http } from 'shared/services/helpers'

function ErrorFallback({ error, resetErrorBoundary }) {
  const errorMessage = useMemo(() => {
    if (error instanceof Error) {
      return error.message
    }

    if (Array.isArray(error)) {
      return error[0]
    }

    if (http.isCustomResponse(error)) {
      return error.error.message
    }

    return null
  }, [error])

  return (
    <Stack height={1} mt="5%" alignItems="center" justifyContent="center">
      <Stack maxWidth="sm">
        <Typography variant="h3">Oops! Ocorreu um erro inesperado</Typography>
        {!!errorMessage && (
          <Alert severity="error" sx={{ mb: 2, mt: 2 }}>
            {errorMessage}
          </Alert>
        )}

        <Button
          disableElevation
          variant="contained"
          onClick={async () => {
            await queryClient.removeQueries('config-meta-ads', {
              type: 'all',
            })
            resetErrorBoundary()
          }}
        >
          Recarregar página
        </Button>
      </Stack>
    </Stack>
  )
}

export default ErrorFallback
